import * as Icon from "@ant-design/icons";
import { Col, Flex, Form, Modal, Row } from "antd";
import Search from "antd/es/input/Search";
import { ColumnsType } from "antd/es/table";
import { useEffect } from "react";
import { AtualizarRateioCentroCustoAtivoModel } from "../../../../models/rateioCentroCusto/atualizarRateioCentroCustoAtivoModel";
import { RateioCentroCustoModel } from "../../../../models/rateioCentroCusto/rateioCentroCustoModel";
import { setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import { atualizarRateioCentroCustoAtivo, buscarRateioCentroCusto, deletarRateioCentroCusto } from "../../../../services/rateioCentroCustoService";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { setBuscaRateioCentroCusto, setEntityRateioCentroCusto, setModalDeletarRateioCentroCusto, setPageRateioCentroCusto } from "../../../../redux/slices/rateioCentroCusto/rateioCentroCustoSlice";
import { BuscarRateioCentroCustoModel } from "../../../../models/rateioCentroCusto/buscarRateioCentroCustoModel";
import { ItemMenuAcoes } from "../../../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../../../components/table/acoesComponent";
import MensagemModal from "../../../../components/modal/mensagem";
import TableComponent from "../../../../components/table/tableComponent";
import { ButtonComponent } from "../../../../components/button/cadastrar";
import { SwitchComponent } from "../../../../components/button/switch";

const GeralPage = () => {
  //estados globais
  const rateioCentroCustoState = useAppSelector((state) => state.rateioCentroCusto);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(setTitle("RATEIOS DE CENTRO DE CUSTO"));
    dispatch(buscarRateioCentroCusto(rateioCentroCustoState.busca));
    form.setFieldsValue({ pesquisar: rateioCentroCustoState.busca.pesquisar });
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityRateioCentroCusto({}));
    dispatch(setPageRateioCentroCusto("cadastrar"));
  };

  const goEditar = (value: RateioCentroCustoModel) => {
    dispatch(setEntityRateioCentroCusto(value));
    dispatch(setPageRateioCentroCusto("cadastrar"));
  };

  const goDeletar = (value: RateioCentroCustoModel) => {
    dispatch(setEntityRateioCentroCusto(value));
    dispatch(setModalDeletarRateioCentroCusto(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarRateioCentroCusto(false));
  };

  const onChangeAtivo = (value: RateioCentroCustoModel) => {
    let args: AtualizarRateioCentroCustoAtivoModel = {
      id: value.id,
      ativo: !value.ativo,
    };
    dispatch(atualizarRateioCentroCustoAtivo({ value: args, busca: rateioCentroCustoState.busca }));
  };

  const onSearch = (value: string) => {
    let busca: BuscarRateioCentroCustoModel = { ...rateioCentroCustoState.busca, pesquisar: value };

    dispatch(setBuscaRateioCentroCusto(busca));
    dispatch(buscarRateioCentroCusto(busca));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
    },
  ];

  const itemsAuto: ItemMenuAcoes[] = [
    {
      label: "Visualizar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
  ];

  const columns: ColumnsType<RateioCentroCustoModel> = [
    {
      title: "RATEIO DE CENTRO DE CUSTO",
      dataIndex: "denominacao",
      width: 100,
      sorter: (a, b) => a.denominacao.localeCompare(b.denominacao),
      sortDirections: ["ascend", "descend", "ascend"],
    },
    {
      title: "AUTOMÁTICO",
      dataIndex: "automatico",
      width: 100,
      align: "center",
      filters: [
        {
          text: "SIM",
          value: "true" as any,
        },
        {
          text: "NÃO",
          value: "false" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.automatico.toString().includes(value),
      render: (_, record) => (record.automatico ? "SIM" : "NÃO"),
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      width: 100,
      align: "center",
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.ativo.toString().includes(value),
      defaultFilteredValue: ["true" as any],
      render: (_, record: any) => <SwitchComponent onChange={() => onChangeAtivo(record)} disabled={record.automatico} checked={record.ativo} />,
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      render: (_, record) => <AcoesComponent record={record} items={record.automatico ? itemsAuto : items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical" form={form}>
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Rateio" onSearch={onSearch} className="searchInput" enterButton style={{ width: 300 }} />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="flex-end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent data={rateioCentroCustoState.list} columns={columns} loading={rateioCentroCustoState.loading} />
      <Modal title={"REMOVER RATEIO DE CENTRO DE CUSTO"} centered width={350} open={rateioCentroCustoState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover o rateio?"
          action={deletarRateioCentroCusto({ value: rateioCentroCustoState.entity.id, busca: rateioCentroCustoState.busca })}
          close={setModalDeletarRateioCentroCusto(false)}
        />
      </Modal>
    </Flex>
  );
};

export default GeralPage;
